import http from '../helpers/http';
import { FilteredOptionsInterface, makeQueryParamsForRequest } from '../entities/FilteredOptions';
import SchoolInterface from '../interfaces/SchoolInterface';
import SchoolAddressInterface from '../interfaces/SchoolAddressInterface';

const School = (token: string) => {
  const headers = {
    'x-access-token': token,
  };

  return {
    list: async (filteredOptions?: FilteredOptionsInterface) => {
      const params = makeQueryParamsForRequest(filteredOptions);
      const result = await http.get('/schools', {
        headers,
        params,
      });
      return result.data;
    },
    show: async (id: string) => {
      const result = await http.get(`/schools/${id}`, {
        headers,
      });
      return result.data;
    },
    create: async (body: Partial<SchoolInterface>) => {
      const result = await http.post(`/schools`, body, { headers });
      return result.data;
    },
    update: async (id: string, body: Partial<SchoolInterface>) => {
      const result = await http.put(`/schools/${id}`, body, { headers });
      return result.data;
    },
    delete: async (id: string) => {
      const result = await http.delete(`/schools/${id}`, {
        headers,
      });
      return result.data;
    },
    //Address
    showAddress: async (schoolId: string) => {
      const result = await http.get(`/schools/${schoolId}/address`, {
        headers,
      });
      return result.data;
    },
    createAddress: async (body: Partial<SchoolAddressInterface>) => {
      const result = await http.post(`/schools/address`, body, { headers });
      return result.data;
    },
    updateAddress: async (id: string, body: Partial<SchoolAddressInterface>) => {
      const result = await http.put(`/schools/${id}/address`, body, { headers });
      return result.data;
    },
    listSelect: async (params?: {}) => {
      const result = await http.get(`/schools/select/all`, {
        headers,
        params,
      });
      return result.data;
    },
    changeTokenSchool: async (body: { id: string }) => {
      const result = await http.patch(`/schools/tokenSchool`, body, { headers });
      return result.data;
    },
    file: async (id: string, body: FormData) => {
      const headers = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-access-token': token,
        },
      };
      const result = await http.patch(`/schools/${id}/file`, body, headers);
      return result.data;
    },
    getSchoolPublic: async (uri: string) => {
      const result = await http.get(`/schools/${uri}/public`);
      return result.data;
    },
    getSchoolStripeCurrent: async (id: string) => {
      const result = await http.get(`/schools/${id}/stripe/current`);
      return result.data;
    },
    updateTourList: async (id: string, tourList: boolean) => {
      const result = await http.put(`/schools/update-tour-list/${id}`, { tourList }, { headers });
      return result.data;
    },
    listMonthlyColors: async (schoolId: string) => {
      const result = await http.get(`/schools/${schoolId}/monthly-colors`, { headers });
      return result.data;
    },
    upsertMonthlyColors: async (schoolId: string, colors: Array<{ month: number; color: string }>) => {
      const result = await http.put(`/schools/${schoolId}/monthly-colors`, { colors }, { headers });
      return result.data;
    },
    listAnniversaryShirts: async (schoolId: string) => {
      const result = await http.get(`/schools/${schoolId}/anniversary-shirts`, { headers });
      return result.data;
    },
    createAnniversaryShirt: async (schoolId: string, body: { years: number; style: string; color: string }) => {
      const result = await http.post(`/schools/${schoolId}/anniversary-shirts`, body, { headers });
      return result.data;
    },
    updateAnniversaryShirt: async (
      schoolId: string,
      shirtId: number,
      body: { years: number; style: string; color: string },
    ) => {
      const result = await http.put(`/schools/${schoolId}/anniversary-shirts/${shirtId}`, body, { headers });
      return result.data;
    },
    deleteAnniversaryShirt: async (schoolId: string, shirtId: number) => {
      const result = await http.delete(`/schools/${schoolId}/anniversary-shirts/${shirtId}`, { headers });
      return result.data;
    },
    listEmailRecipients: async (schoolId: string) => {
      const result = await http.get(`/schools/${schoolId}/email-recipients`, { headers });
      return result.data;
    },
    createEmailRecipient: async (schoolId: string, email: string) => {
      const result = await http.post(`/schools/${schoolId}/email-recipients`, { email }, { headers });
      return result.data;
    },
    deleteEmailRecipient: async (schoolId: string, recipientId: number) => {
      const result = await http.delete(`/schools/${schoolId}/email-recipients/${recipientId}`, { headers });
      return result.data;
    },
  };
};

export default School;
